/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useSearch } from '@tanstack/react-router';

type MultiplePDFRequest = {
  companyId: string;
  language: string;
  countriesAndPlansSelected: Array<string>;
};

type CountryPlanObject = {
  countryCode: string;
  countryName: string;
  planId: number;
};

type InputItem = string;
type OutputItem = {
  countryCode: string;
  countryName: string;
  planId: number;
};

const defaultRequest = {
  medium: 'zip',
  serviceName: 'tax_guide',
  templateType: 'adminPreview',
};

export const Route = createFileRoute('/downloadMultiplePdf/')({
  loader: ({ params }) => {
    console.log(params);
  },
  component: () => {
    //@ts-ignore
    const search = useSearch({ strict: false });
    const { companyId, language, countriesAndPlansSelected } =
      search as MultiplePDFRequest;

    const countryPlanArrayTranformed: Array<CountryPlanObject> =
      useWebToDomainTransformer(countriesAndPlansSelected);

    const requestObject = {
      ...defaultRequest,
      countriesAndPlansSelected: countryPlanArrayTranformed,
      companyId,
      language,
    };

    useEffect(() => {
      function downloadCall() {
        let resp = new Response();
        return fetch(`/gi/downloadMultipleTaxGuide`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestObject),
        })
          .then(response => {
            if (response.status === 200) {
              resp = response; // Assign the response to 'resp'
              return response.blob();
            } else return null;
          })
          .then(blob => {
            if (!blob) {
              console.log('No blob for zip');
              window.alert(
                'Error downloading PDF at the moment. Please try after sometime!',
              );
            } else {
              let filename = 'multiPDF.zip';
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              const contentDisposition = resp.headers?.get(
                'Content-Disposition',
              );
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches =
                contentDisposition && filenameRegex.exec(contentDisposition);

              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, ''); // Remove any quotes
              }
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);

              window.URL.revokeObjectURL(url);
            }
          })
          .catch(() => {
            console.log('Error in reaching multipdf download service');
            window.alert(
              'Error downloading PDF at the moment. Please try after sometime!',
            );
          });
      }

      if (countryPlanArrayTranformed.length > 0) downloadCall();
    }, []);

    return null;
  },
});

const useWebToDomainTransformer = (inputArray: InputItem[]): OutputItem[] => {
  console.log('inputArray', inputArray);
  const transformedArray = inputArray.map(item => {
    const [countryCode, countryName, planId] = item.split('*');
    return {
      countryCode,
      countryName,
      planId: parseInt(planId, 10),
    };
  });

  return transformedArray;
};
